import { isOpenSizingSellingMethodAllowed } from '@/utils/product/checkAttribute';
import { isValidNumber, toString } from '@/utils/number';
import { replaceOperation } from '@/utils/product/operations';
import { editShipping } from '@/utils/edit/shipping';

import { OPERATIONS, SELLING_METHOD, VALUE } from '@/constants/product';
import { EBAY, ETSY, FAIRE } from '@/constants/channels';
import { ATTRIBUTE } from '@/constants/attributes';
import { EMPTY } from '@/constants';
import { FORM } from '@/constants/forms';

export function shipping({ operation, product, ...rest }) {
  const channel = product.get('channel');
  const operationType = operation.get('type');

  switch (channel) {
    case EBAY: {
      switch (operationType) {
        case OPERATIONS[EBAY].COUNTRY: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.COUNTRY]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].DEPTH: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.DEPTH]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].IRREGULAR: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.IRREGULAR]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].LENGTH: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.LENGTH]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].LOCATION: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.LOCATION]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].PAYMENT_POLICY: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.PAYMENT_POLICY]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].POSTAL_CODE: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.POSTAL_CODE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].RETURN_POLICY: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.RETURN_POLICY]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].SHIPPING_POLICY: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.SHIPPING_POLICY]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].WEIGHT_MAJOR: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.WEIGHT_MAJOR]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].WEIGHT_MINOR: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.WEIGHT_MINOR]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].WIDTH: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.WIDTH]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case ETSY: {
      switch (operationType) {
        case OPERATIONS[ETSY].PROCESSING_PROFILE: {
          const { shop, shopData } = rest;
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.PROCESSING_PROFILE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].SHIPPING_PROFILE: {
          if (product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
            return { product, ...rest };
          }

          const { shop, shopData } = rest;
          const profileId = operation.get('value');
          const profileType = shopData.getIn(['shippingProfiles', 'byId', profileId, 'profileType']);
          const updates = editShipping({
            product,
            shop,
            shopData,
            [ATTRIBUTE.PROFILE_ID]: profileId,
            [ATTRIBUTE.PROFILE_TYPE]: profileType,
          });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].RETURN_POLICY: {
          if (product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
            return { product, ...rest };
          }

          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.RETURN_POLICY]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].HEIGHT: {
          if (product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
            return { product, ...rest };
          }

          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.HEIGHT]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].LENGTH: {
          if (product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
            return { product, ...rest };
          }

          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.LENGTH]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].WEIGHT: {
          if (product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
            return { product, ...rest };
          }

          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.WEIGHT]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].WIDTH: {
          if (product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
            return { product, ...rest };
          }

          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({ product, shop, shopData, [ATTRIBUTE.WIDTH]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case FAIRE: {
      switch (operationType) {
        case OPERATIONS[FAIRE].CASE_SIZE: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const values = {
            [ATTRIBUTE.CASE_SIZE]: toString(value) || '',
          };

          if (isValidNumber(value) && value > 1) {
            values[ATTRIBUTE.SELLING_METHOD] = SELLING_METHOD.CASE;
          }

          const updates = editShipping({ product, shop, shopData, ...values });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].MINIMUM_ORDER_QUANTITY: {
          const { shop, shopData } = rest;
          const value = operation.get('value');
          const updates = editShipping({
            product,
            shop,
            shopData,
            [ATTRIBUTE.MINIMUM_ORDER_QUANTITY]: toString(value) || '',
          });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].PER_STYLE_MINIMUM_ORDER_QUANTITY: {
          const { shop, shopData } = rest;
          const value = operation.get('value');

          if (!!value && !isOpenSizingSellingMethodAllowed(product.get(FORM.VARIATIONS))) {
            return { product, ...rest };
          }

          const values = {
            [ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY]: toString(value) || '',
          };

          if (isValidNumber(value) && value > 1) {
            values[ATTRIBUTE.SELLING_METHOD] = SELLING_METHOD.SIZE;
          }

          const updates = editShipping({ product, shop, shopData, ...values });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    default: {
      return { product, ...rest };
    }
  }
}
